module.exports = [{
      plugin: require('../../../../../home/tarim/projects/beacons/git/gatsby/node_modules/gatsby-plugin-emotion/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
